<offer-price>
    <h5 class="block-title hint-text text-center no-margin"><b>Purchase offer for</b></h5>
    <br>
    <h6 class="block-title hint-text text-center no-margin">
        {opts.offer.description}
    </h6>
    <br>
    <hr>
    <div>
        <div class="card no-margin w-100 clickable {'pricing__active': specs === 'HD'}"
             ref="HD"
             style="cursor: pointer"
             onclick="{setSpecs('HD')}"
        >
            <div class="row padding-20">
                <div class="col-5">
                    <p><b>HD</b></p>
                    <p>{showPrice('HD')}</p>
                </div>
                <div class="col-7 text-right">
                    <ul class="list-unstyled">
                        <li>size: HD</li>
                        <li>deliverable: Asset will be delivered in 2-3 days.</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="card no-margin w-100 clickable  {'pricing__active': specs === 'WEB_LG'}"
             ref="WEB_LG"
             style="cursor: pointer"
             onclick="{setSpecs('WEB_LG')}"
        >
            <div class="row padding-20">
                <div class="col-5">
                    <p><b>WEB_LG</b></p>
                    <p>{showPrice('WEB_LG')}</p>
                </div>
                <div class="col-7 text-right">
                    <ul class="list-unstyled">
                        <li>size: 1920x1080</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="card no-margin w-100 clickable {'pricing__active': specs === 'WEB_MD'}"
             ref="WEB_MD"
             style="cursor: pointer"
             onclick="{setSpecs('WEB_MD')}"
        >
            <div class="row padding-20">
                <div class="col-5">
                    <p><b>WEB_MD</b></p>
                    <p>{showPrice('WEB_MD')}</p>
                </div>
                <div class="col-7 text-right">
                    <ul class="list-unstyled">
                        <li>size: 1024x576</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <h4 class="text-center">
        {getPrice()} €
    </h4>

    <hr>

    <button onclick="{addToCart}" class="btn aero-btn-primary btn-lg w-100">add to Cart</button>

    <script>

        // import utils

        import swal from 'sweetalert';

        import './pricing.css';

        const tag = this;

        tag.specs = 'WEB_LG';
        tag.license = 'editorial';


        tag.parseProduct = () => {
            return {
                category: 'offer',
                license: tag.license,
                specs: tag.specs,
                content: {
                    id: opts.offer.id,
                    price: !!(tag.specs !== 'WEB_SM') ? opts.offer[tag.specs] : opts.offer[tag.license],
                    name: opts.offer.name,
                    description: opts.offer.description,
                }

            }
        };


        tag.setSpecs = (specs) => {
            return () => {
                tag.specs = specs;
                tag.license = 'editorial';
            }
        };

        tag.setDigiShare = () => {
            tag.specs = 'WEB_SM';
            tag.license = 'DigiShare'
        };

        tag.showPrice = (specs) => {
            if (specs !== 'WEB_SM')
                return opts.offer[specs].toFixed(2).replace('.', ',');
            else
                return opts.offer['DigiShare'].toFixed(2).replace('.', ',')
        };

        tag.getPrice = () => {
            if (tag.specs !== 'WEB_SM')
                return opts.offer[tag.specs].toFixed(2).replace('.', ',');
            else
                return opts.offer[tag.license].toFixed(2).replace('.', ',')
        };

        tag.addToCart = (event) => {
            event.preventUpdate = true;
            if (!window.user)
                return tag.onUnauthorized();

            if (opts.addToCart) {
                return opts.addToCart(tag.parseProduct())
            }
        };

        tag.onUnauthorized = () => {
            return swal({
                title: 'Sign in required',
                text: 'You must be signed in to proceed. Account creation is free',
                icon: 'info',
                buttons: {
                    login: {
                        text: 'Sign in',
                        value: 'login'
                    },
                    register: {
                        text: 'Sign up',
                        value: 'register'
                    },
                    cancel: true,
                }
            }).then((value) => {
                if (value === 'login')
                    window.location.href = `/login?next=${window.location.href}`.replace(window.eshop, '');

                if (value === 'register')
                    window.location.href = '/signup';
            })
        };

    </script>
</offer-price>


// WEBPACK FOOTER //
// avr_eshop/frontend/components/pricing/offer-price.tag.html